import { Button } from "../../../shared/components/buttons/Button";

type Variant = "invalid-id" | "forbidden" | "not-found" | "generic";

type Props = {
	variant: Variant;
	message?: string;
	onRetry?: () => void;
	onHome: () => void;
};

const copy: Record<
	Variant,
	{ code: string; title: string; description: string }
> = {
	"invalid-id": {
		code: "400",
		title: "Невірний ID кампанії",
		description:
			"Потрібен 11-значний ідентифікатор кампанії Google Ads.",
	},
	forbidden: {
		code: "403",
		title: "Доступ заборонено",
		description:
			"У вас немає прав переглядати цю картку кампанії або сесія закінчилася.",
	},
	"not-found": {
		code: "404",
		title: "Кампанію не знайдено",
		description:
			"Жодної картки кампанії не знайдено для вказаного ID кампанії.",
	},
	generic: {
		code: "403",
		title: "Доступ заборонено",
		description:
			"Не вдалося отримати картку кампанії. Перевірте права доступу або зверніться до адміністратора.",
	},
};

export const CampaignDetailError = ({
	variant,
	message,
	onRetry,
	onHome,
}: Props) => {
	const content = copy[variant];
	const detail = message?.trim() || content.description;

	return (
		<div className='campaign-detail__error-state'>
			<div className='campaign-detail__error-card'>
				<div className='campaign-detail__error-code' aria-hidden>
					{content.code}
				</div>
				<div className='campaign-detail__error-icon' aria-hidden>
					<svg viewBox='0 0 24 24' width='40' height='40' fill='none'>
						<path
							d='M12 2a5 5 0 0 1 5 5v2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5Z'
							stroke='currentColor'
							strokeWidth='1.5'
						/>
						<path
							d='M9 14h6'
							stroke='currentColor'
							strokeWidth='1.5'
							strokeLinecap='round'
						/>
					</svg>
				</div>
				<h2 className='campaign-detail__error-title'>{content.title}</h2>
				<p className='campaign-detail__error-description'>{detail}</p>
				<div className='campaign-detail__error-actions'>
					{onRetry && (
						<Button onClick={onRetry}>Спробувати знову</Button>
					)}
					<Button onClick={onHome}>На головну</Button>
				</div>
			</div>
		</div>
	);
};
